import 'isomorphic-fetch';
import { applyMiddlewares, AuthBearerMiddleware } from 'redux-saga-resources';

import { put } from '../redux-saga';
import selectors from './selectors';

import LOGGEDOUT from './actions/LOGGEDOUT';

export const authMiddleware = applyMiddlewares<any>(AuthBearerMiddleware(selectors.token as any), logout401);

const httpUnauthorized = 401;

function* logout401({ response }: any, next: any) {
  yield* next();

  if (response.statusCode === httpUnauthorized) {
    yield put(LOGGEDOUT({ }));
  }
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/auth/resource.tsx